import { render } from "./designDescription.vue?vue&type=template&id=3c7a8ae8&scoped=true"
import script from "./designDescription.vue?vue&type=script&lang=js"
export * from "./designDescription.vue?vue&type=script&lang=js"

import "./designDescription.vue?vue&type=style&index=0&id=3c7a8ae8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7a8ae8"]])

export default __exports__